import React, { useContext, useState } from "react";
import { toast } from "react-toastify";
import { defaultToastOptions, setDTConfig } from "../index.js";
import ProTip from "../../../../../../../merchant/panel/scripts/shared/ProTip/ProTip.js";
import executeRequest from "../../../../../modules/request.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import { useGlobalUpdate } from "../../scripts/useGlobalUpdate.js";
import { DisposableOfferOrder } from "../disposableOfferOrder/disposableOfferOrder.js";
import ImageOrder from "../imageOrder/imageOrder.js";
import { openLoginMenu, groupContext } from "../index.js";
import { UpdateBasketItemsCount } from "../navbar/navBar.js";
import "./orderedImagesList.css";
export default function OrderedImagesList(props) {
    const [loadingImageIndex, setLoadingImageIndex] = useState(undefined);
    const group = useContext(groupContext);
    const { emit, state } = useGlobalUpdate(UpdateBasketItemsCount);
    function updateOrder(orderedImageData, format, count) {
        const orderData = {
            image: orderedImageData.imageName,
            offerName: orderedImageData.orderType,
            formats: orderedImageData.orderedFormats.map((f) => f.name != format ?
                f
                : { name: f.name, count: count, pricePerItem: f.pricePerItem }),
            selectedCustomization: orderedImageData.selectedCustomization,
            electronicFile: orderedImageData.orderedElectronicFile,
        };
        executeRequest("/api/public/users/gallery/orders/add", "POST", orderData).then((response) => {
            if (response.status === 400) {
                toast.error("Nie udało się zmienić zamówienia", defaultToastOptions);
                return;
            }
            if (response.status === 403) {
                toast.error("Zamówienie oczekuje na płatność i nie może już być edytowane. Możesz utworzyć nowe zamówienie lub opłacić aktualne.", defaultToastOptions);
                return;
            }
            props.updateRequest();
            return;
        });
    }
    function deleteImage(orderedImageData) {
        executeRequest("/api/public/users/gallery/orders/remove", "PATCH", {
            image: orderedImageData.imageName,
            offerName: orderedImageData.orderType,
        }).then((response) => {
            setLoadingImageIndex(undefined);
            if (response.status == 403) {
                toast.error("Zamówienie oczekuje na płatność i nie może już być edytowane. Możesz utworzyć nowe zamówienie lub opłacić aktualne.", defaultToastOptions);
                return;
            }
            //possible complications in the future
            emit(state + 1);
            props.updateRequest();
        });
    }
    return (React.createElement("div", { className: "ordered-images-list-container" },
        props.orders.length == 0 && props.disposableItems.length == 0 ?
            "Twój koszyk jest pusty"
            : "",
        props.status === 401 && (React.createElement("div", { className: "login-button-container" },
            "Nie widzisz swojego zam\u00F3wienia?",
            React.createElement(Button, { onClick: () => {
                    var _a, _b;
                    openLoginMenu({
                        needsName: group.clientData.name,
                        needsEmail: group.clientData.email,
                        needsPhone: group.clientData.phone,
                        flow: (_a = group.flow) === null || _a === void 0 ? void 0 : _a.onFirstOrderIntent,
                        componentList: (_b = group.flow) === null || _b === void 0 ? void 0 : _b.componentsList,
                        onLogin: () => {
                            setDTConfig((c) => ({ ...c, isLoggedIn: "true" }));
                            props.updateRequest();
                            emit(state + 1);
                        },
                        loginType: "login",
                        allowLoginToOrder: group.allowLoginToOrder,
                    });
                } }, "Zaloguj si\u0119"))),
        React.createElement("ul", { className: "ordered-images-list" },
            props.readonlyMode === true && (React.createElement(ProTip, { withoutPrefix: true }, "To zam\u00F3wienie jest w trybie podgl\u0105du i nie mo\u017Ce ju\u017C by\u0107 edytowane")),
            props.orders.map((order, index) => (React.createElement(ImageOrder, { isReadonly: props.readonlyMode, key: index, isLoading: loadingImageIndex === index, imageOrders: props.orders.filter((o) => o.categoryName === order.categoryName &&
                    o.imageName === order.imageName), orderData: order, onImageDelete: () => {
                    setLoadingImageIndex(index);
                    deleteImage(order);
                }, onElectronicFileUpdate: (hasSelected) => {
                    updateOrder({ ...order, orderedElectronicFile: hasSelected }, undefined, 0);
                }, onOrderUpdate: (format, count) => {
                    updateOrder(order, format, count);
                } }))),
            props.disposableItems.map((item, index) => (React.createElement(DisposableOfferOrder, { key: index, item: item, onUpdate: props.updateRequest }))))));
}
